export class OptiData {
  id: bigint;
  od_user_id: number;
  od_batch_date: any;
  od_cut_start_date: any;
  od_cut_end_date: any;
  od_batch_number: number;
  od_opti_group: number;
  od_product_id: string;
  od_width: number;
  od_height: number;
  od_depth: number;
  od_stock_plates_number: number;
  od_product_desc: string;
  od_net_area: number;
  od_gross_area: number;
  od_porcentage_wastage: number;
  od_optimization_time: number;
  od_oef_used: boolean;
  od_oef_phase: number;
  od_oef_preset: string;
  od_oef_summary: any;
  od_net_area_weight: number;
  od_customers_number: number;
  od_customers: string;
  od_total_pieces: number;
  od_total_easels: number;
  od_configuration: string;
  od_opti_number: string;
  od_lots_number: string;
  od_notes: string;
  od_state: string;
  od_layout_snapshot: any;
}
